<!-- Loading state -->
<ng-container *ngIf="isLoading === false; else loadTemplate">
  
  <!-- Close button -->
  <div class="dialog-header">
    <button mat-icon-button class="close-button" aria-label="Chiudi dialog" (click)="onNoClick(currentStep)">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Container principale con contenuto o empty state -->
  <ng-container *ngIf="this.items?.length > 0; else noItemTemplate">
    
    <div class="packaging-dialog-container">
      
      <!-- Material Stepper per mostrare il progresso -->
      <mat-stepper [linear]="true" [selectedIndex]="currentStep - 1" #stepper>
        
        <!-- STEP 1: Selezione articoli -->
        <mat-step [completed]="step1Completed">
          <ng-template matStepLabel>Seleziona articoli</ng-template>
          
          <div class="step-content">
            <h2 class="step-title">Crea il tuo packaging</h2>
            <p class="step-subtitle">Seleziona gli articoli da inserire nel packaging</p>

            <!-- Material Table con selezione -->
            <div class="table-container">
              <table mat-table [dataSource]="paginatedItems" class="items-table">
                
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox 
                      (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <mat-checkbox 
                      (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                  </td>
                </ng-container>

                <!-- Codice Column -->
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef>Codice articolo</th>
                  <td mat-cell *matCellDef="let item">
                    <strong>{{ item.ItemCode }}</strong>
                  </td>
                </ng-container>

                <!-- Nome Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Nome articolo</th>
                  <td mat-cell *matCellDef="let item">{{ item.ItemName }}</td>
                </ng-container>

                <!-- Quantità Column -->
                <ng-container matColumnDef="quantity">
                  <th mat-header-cell *matHeaderCellDef class="text-center">Quantità disponibile</th>
                  <td mat-cell *matCellDef="let item" class="text-center">
                    <span class="quantity-badge">{{ item.Stock }}</span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
                    (click)="selection.toggle(row)"
                    [class.selected-row]="selection.isSelected(row)">
                </tr>
              </table>

              <!-- Paginator Custom -->
              <div class="custom-paginator">
                <div class="paginator-left">
                  <span class="paginator-total">Totale {{ items?.length || 0 }} </span>
                </div>
                <div class="paginator-center">
                  <span class="paginator-label"></span>
                  <select class="paginator-select" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
                    <option [value]="5">5</option>
                    <option [value]="10">10</option>
                    <option [value]="20">20</option>
                  </select>
                </div>
                <div class="paginator-right">
                  <span class="paginator-range">{{ getPageRange() }}</span>
                  <button mat-icon-button 
                          class="paginator-btn" 
                          [disabled]="currentPage === 0"
                          (click)="firstPage()">
                    <mat-icon>first_page</mat-icon>
                  </button>
                  <button mat-icon-button 
                          class="paginator-btn"
                          [disabled]="currentPage === 0"
                          (click)="previousPage()">
                    <mat-icon>chevron_left</mat-icon>
                  </button>
                  <span class="paginator-page">{{ currentPage + 1 }}</span>
                  <button mat-icon-button 
                          class="paginator-btn"
                          [disabled]="currentPage >= getPageCount() - 1"
                          (click)="nextPage()">
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                  <button mat-icon-button 
                          class="paginator-btn"
                          [disabled]="currentPage >= getPageCount() - 1"
                          (click)="lastPage()">
                    <mat-icon>last_page</mat-icon>
                  </button>
                </div>
              </div>
            </div>

            <!-- Action buttons -->
            <div class="step-actions">
              <button mat-raised-button color="warn" (click)="onNoClick(1)">
                <mat-icon>close</mat-icon>
                Annulla
              </button>
              <button 
                mat-raised-button 
                color="primary" 
                [disabled]="selection.selected.length < 1"
                (click)="submit(1)">
                Avanti
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>

            <!-- Info selezione -->
            <div class="selection-info" *ngIf="selection.selected.length > 0">
              <mat-icon>info</mat-icon>
              <span>{{ selection.selected.length }} articoli selezionati </span>
            </div>
          </div>
        </mat-step>

        <!-- STEP 2: Inserimento quantità -->
        <mat-step [completed]="step2Completed">
          <ng-template matStepLabel>Imposta quantità</ng-template>
          
          <div class="step-content">
            <h2 class="step-title">Definisci le quantità</h2>
            <p class="step-subtitle">Inserisci la quantità per ogni articolo selezionato</p>

            <form [formGroup]="itemForm" class="quantity-form">
              <div formArrayName="itemsArray" class="quantity-items">
                <mat-card *ngFor="let control of itemsArray.controls; let i = index" 
                          [formGroupName]="i" 
                          class="quantity-item-card">
                  
                  <mat-card-content>
                    <div class="item-info">
                      <div class="item-details">
                        <strong class="item-code">{{ selectedItemConfiguration.itemHandlings[i].Item.Code }}</strong>
                        <span class="item-name">{{ selectedItemConfiguration.itemHandlings[i].Item.Name }}</span>
                        <span class="item-stock">Disponibili: {{ selectedItemConfiguration.itemHandlings[i].CTManagerItemStock?.Stock }}</span>
                      </div>
                      
                      <mat-form-field appearance="outline" class="quantity-field">
                        <mat-label>Quantità</mat-label>
                        <input 
                          matInput 
                          type="number" 
                          formControlName="qty" 
                          min="1"
                          [max]="selectedItemConfiguration.itemHandlings[i].CTManagerItemStock?.Stock">
                        <mat-icon matSuffix>inventory_2</mat-icon>
                        <mat-error *ngIf="control.get('qty')?.hasError('required')">
                          Quantità obbligatoria
                        </mat-error>
                        <mat-error *ngIf="control.get('qty')?.hasError('min')">
                          Minimo 1
                        </mat-error>
                        <mat-error *ngIf="control.get('qty')?.hasError('max')">
                          Massimo {{ selectedItemConfiguration.itemHandlings[i].CTManagerItemStock?.Stock }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </form>

            <!-- Action buttons -->
            <div class="step-actions">
              <button mat-raised-button matStepperPrevious>
                <mat-icon>arrow_back</mat-icon>
                Indietro
              </button>
              <button 
                mat-raised-button 
                color="primary"
                [disabled]="itemForm.invalid"
                (click)="submit(2)">
                Avanti
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </div>
        </mat-step>

        <!-- STEP 3: Selezione/Creazione packaging -->
        <mat-step [completed]="step3Completed">
          <ng-template matStepLabel>Seleziona packaging</ng-template>
          
          <div class="step-content">
            <h2 class="step-title">Scegli o crea un packaging</h2>
            <p class="step-subtitle">Seleziona un packaging esistente o creane uno nuovo</p>

            <!-- Packaging selection -->
            <div class="packaging-selection" *ngIf="packagies">
              <form [formGroup]="packagingForm" class="packaging-form">
                <mat-form-field appearance="outline" class="packaging-select">
                  <mat-label>Packaging</mat-label>
                  <mat-select formControlName="packagingControl" placeholder="Seleziona un packaging">
                    <mat-option *ngFor="let pack of packagies" [value]="pack.Oid">
                      {{ pack.Name }}
                    </mat-option>
                  </mat-select>
                  <mat-icon matSuffix>inventory</mat-icon>
                  <mat-error *ngIf="packagingForm.get('packagingControl')?.hasError('required')">
                    Seleziona un packaging
                  </mat-error>
                </mat-form-field>

                <button 
                  mat-raised-button 
                  color="accent" 
                  type="button"
                  (click)="createPackaging()"
                  class="create-packaging-btn">
                  <mat-icon>add</mat-icon>
                  Crea nuovo
                </button>
              </form>

              <!-- Empty state per packaging -->
              <div class="empty-packaging-state" *ngIf="packagies.length === 0">
                <mat-icon>inventory</mat-icon>
                <p>Nessun packaging disponibile</p>
                <small>Crea il primo packaging per questo ordine</small>
              </div>
            </div>

            <!-- Action buttons -->
            <div class="step-actions">
              <button mat-raised-button matStepperPrevious>
                <mat-icon>arrow_back</mat-icon>
                Indietro
              </button>
              <button 
                mat-raised-button 
                color="primary"
                [disabled]="packagingForm.invalid"
                (click)="submit(3)">
                Avanti
                <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </div>
        </mat-step>

        <!-- STEP 4: Riepilogo finale -->
        <mat-step [completed]="step4Completed">
          <ng-template matStepLabel>Conferma</ng-template>
          
          <div class="step-content">
            <h2 class="step-title">Riepilogo finale</h2>
            <p class="step-subtitle">Verifica i dati prima del salvataggio</p>

            <!-- Summary cards -->
            <div class="summary-section">
              
              <!-- Packaging info -->
              <mat-card class="summary-card" *ngIf="getCurrentPackaging()">
                <mat-card-header>
                  <mat-icon mat-card-avatar>inventory</mat-icon>
                  <mat-card-title>Packaging selezionato</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="packaging-name">{{ getCurrentPackaging() }}</div>
                </mat-card-content>
              </mat-card>

              <!-- Items list -->
              <mat-card class="summary-card items-summary">
                <mat-card-header>
                  <mat-icon mat-card-avatar>list_alt</mat-icon>
                  <mat-card-title>Articoli selezionati</mat-card-title>
                  <mat-card-subtitle>{{ itemsArray.length }} articoli</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <mat-list class="summary-list">
                    <mat-list-item *ngFor="let control of itemsArray.controls; let i = index">
                      <mat-icon matListItemIcon>inventory_2</mat-icon>
                      <div matListItemTitle class="item-summary-title">
                        <strong>{{ selectedItemConfiguration.itemHandlings[i].Item.Code }} </strong>
                        <span class="item-summary-name"> {{ selectedItemConfiguration.itemHandlings[i].Item.Name }}</span>
                      </div>
                      <div matListItemLine class="item-summary-qty">
                        Quantità: <strong>{{ selectedItemConfiguration.itemHandlings[i].StartQty }}</strong>
                      </div>
                    </mat-list-item>
                  </mat-list>
                </mat-card-content>
              </mat-card>
            </div>

            <!-- Action buttons -->
            <div class="step-actions">
              <button mat-raised-button matStepperPrevious>
                <mat-icon>arrow_back</mat-icon>
                Indietro
              </button>
              <button 
                mat-raised-button 
                color="primary"
                (click)="createHandling()">
                <mat-icon>save</mat-icon>
                Salva packaging
              </button>
            </div>
          </div>
        </mat-step>

        <!-- STEP 5: Conferma successo -->
        <mat-step [completed]="step5Completed">
          <ng-template matStepLabel>Completato</ng-template>
          
          <div class="step-content success-content">
            <div class="success-message">
              <mat-icon class="success-icon">check_circle</mat-icon>
              <h2>Packaging creato con successo!</h2>
              <p>Il packaging è stato salvato correttamente</p>
            </div>

            <div class="step-actions">
              <button mat-raised-button color="primary" (click)="onNoClick(5)">
                <mat-icon>done</mat-icon>
                Chiudi
              </button>
            </div>
          </div>
        </mat-step>

      </mat-stepper>
    </div>

  </ng-container>

  <!-- Empty state quando non ci sono articoli -->
  <ng-template #noItemTemplate>
    <div class="empty-state-container">
      <div class="empty-state-content">
        <mat-icon class="empty-state-icon">inventory_2</mat-icon>
        <h2 class="empty-state-title">Nessun articolo disponibile</h2>
        <p class="empty-state-message">
          Non ci sono articoli in stock per creare un packaging. 
          Aggiungi degli articoli all'ordine prima di procedere.
        </p>
        <button mat-raised-button color="warn" (click)="onNoClick(1)">
          <mat-icon>close</mat-icon>
          Chiudi
        </button>
      </div>
    </div>
  </ng-template>

</ng-container>

<!-- Loading template -->
<ng-template #loadTemplate>
  <div class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="loading-text">Caricamento in corso...</p>
  </div>
</ng-template>
